import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16ead44e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fullscreen-spin"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FullscreenSpin',
  props: {
  loading: {
    type: Boolean,
    default: false,
  },
  tip: {
    type: String,
    default: '',
  },
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_Spin = _resolveComponent("Spin")!

  return (__props.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Spin, {
          tip: __props.tip,
          size: "large"
        }, null, 8, ["tip"])
      ]))
    : _createCommentVNode("", true)
}
}

})